export default function downloadFile(link, fileName = '') {
  const a = document.createElement('a');
  a.style.display = 'none';

  a.setAttribute('href', link);
  a.setAttribute('download', fileName);
  a.setAttribute('target', '_blank');

  a.click();
}
